export default __webpack_public_path__ + "static/media/win_four.7b9020aa.svg";